import { ViewType, ViewObject } from '../base';

import { dataService } from '../../data';
import { Employee } from '../objects/employee';
import { UserView } from './user';

/****************************/
/* CLASS VIEW               */
/****************************/

export class _EmployeeView extends ViewObject<Employee> {

    /**********************************/
    /* VIEWOBJECT IMPLEMENTATION      */
    /**********************************/

    private get employee(): Employee{
        return this.object;
    }
             
    constructor(object: Employee, data: dataService){
        super(object, data);
    }

    override OnDestroy(): void {
        super.OnDestroy();
    }

    /**********************************/
    /* VIEW MANAGED INFORMATION       */
    /**********************************/

    private RefreshView(targets: string[]){
        if (targets.includes('STAFF')){
            this.DoRefreshView();
        }
    }

    /**********************************/
    /* CHILDREN REGISTRATION          */
    /**********************************/

    override doRegister(): void{
        const weakref = new WeakRef(this);

        // deregister of current subscriptions
        for (const _subsription of this._subscriptions){
            _subsription.unsubscribe();
        }
        this._subscriptions = [];

        // register to updates on contained items             
        this._subscriptions.push(
            this.employee.OnRefresh.subscribe(
            (targets: string[]) => {
                const self = weakref.deref();
                if (self){  // do not keep strong references in subscription
                    self.RefreshView(targets);
                }
            })
        )
    }

    /**********************************/
    /* ACTIVE CHILDREN INFORMATION    */
    /**********************************/
    
    get user(): UserView | null {
        return this.data.alives.get(this.employee.user) as UserView;
    }

    /**********************************/
    /* CUSTOM METHODS                 */
    /**********************************/
    
    get IsActive(): boolean {
        if (!this.employee.user){
            return false;
        }

        return this.employee.user.IsActive;
    }    
}

/****************************/
/* PROXY VIEW               */
/****************************/

export type EmployeeView = ViewType <_EmployeeView, Employee>;

export function EmployeeViewProxy(object: Employee, data: dataService): EmployeeView {
    return new _EmployeeView(object, data).Proxy as EmployeeView;
}
